import { useTranslation } from 'react-i18next';
import { useDashboardDaysStore } from '../../../../models/useDashboardDaysModel';
import { useUtcOffsetStore } from '../../../../models/useUtcOffsetModel';
import { DashboardPeriod } from '../../../../types/dashboard';
import { getUtcTime } from '../../../../utils/time';
import TableTemplate from '../../Charts/TableTemplate';
import DashboardCard from '../../Layout/DashboardCard';
import { ScamData, ScamWidgetId } from './type';

export const ScamBySourceType = ({
  data,
}: {
  data: Pick<ScamData, ScamWidgetId.ScamByFilter>;
}) => {
  const { t } = useTranslation();
  const {
    days: { DashboardScam: day },
  } = useDashboardDaysStore();
  const { offset } = useUtcOffsetStore();

  const config = [
    { width: '23%', grow: 2, align: 'left', tooltip: true },
    { width: '15%', grow: 1, align: 'right' },
    { width: '15%', grow: 1, align: 'left', tooltip: true },
  ];

  const header = [
    t('dashboard.chart.column.securityFilter'),
    t('dashboard.chart.column.detections'),
    t('dashboard.chart.column.lastDetected'),
  ];

  const tableData = (
    data?.[ScamWidgetId.ScamByFilter]?.[day as DashboardPeriod] || []
  ).map((item) => [
    item.key,
    item.total,
    getUtcTime(item.last_detected, offset, t('common.momentDateFormat')) || '',
  ]);

  return (
    <DashboardCard
      title={t(`dashboard.chart.title.scamBySecurityFilter`)}
      iconContent={t(`dashboard.chart.desc.scamBySecurityFilter`)}
    >
      <TableTemplate config={config} header={header} data={tableData} />
    </DashboardCard>
  );
};
